// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31QGf","field":"styles_field__2dvgq","fieldCol":"styles_fieldCol__2DXkZ","diffCol":"styles_diffCol__Dbp20","diff":"styles_diff__1L4zi"};